import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';

class MassUpdateSummary extends DomainObject {
  payRate;
  previousPayRate;
  employee;
  errorMessage;
  fields = {};

  _relations = {
    employee: Employee
  };

  constructor(other) {
    super();

    makeObservable(this, {
      payRate: observable,
      previousPayRate: observable,
      employee: observable,
      errorMessage: observable,
      fields: observable
    });

    this.merge(other);
  }
}

export default MassUpdateSummary;
